const Login = () => import("../components/content/onboard/login");
const Signup = () => import("../components/content/onboard/signup");
const Calendar = () => import("../components/content/onboard/calendar");
const Decision = () => import("../components/content/onboard/decision");
const SetupPayroll = () => import("../components/content/onboard/setupPayroll");
const OnboardForm = () => import("../components/content/onboard/onboardform");
const VerifyEmail = () => import("../components/content/onboard/verifyEmail");

const ForgotPassword = () =>
  import("../components/content/onboard/forgotPassword");
const SetPassword = () => import("../components/content/onboard/setPassword");
const ChangePassword = () => import("../components/content/onboard/changePassword");
const OnboardPayroll = () =>
  import("../components/content/onboard/onboardPayroll");
const OnboardUser = () => import("../components/content/onboard/onboardUser");
const OnboardSuccess = () =>
  import("../components/content/onboard/onboardSuccess");
const SetupEmployeePassword = () =>
  import("../components/content/onboard/setupEmployeePassword");

export const loginRoute = {
  path: "/login",
  component: Login
};

export const setupPasswordRoute = {
  path: "/setup-password",
  component: SetupEmployeePassword
};

export const signupRoute = {
  path: "/signup",
  component: Signup
};

export const calendarRoute = {
  path: "/calendar",
  component: Calendar
};

export const decisionRoute = {
  path: "/decision",
  component: Decision
};

export const setupPayrollRoute = {
  path: "/setup-payroll",
  component: SetupPayroll
};

export const onboardformRoute = {
  path: "/onboardform",
  component: OnboardForm
};
export const forgotPasswordRoute = {
  path: "/forgot-password",
  component: ForgotPassword
};

export const setPasswordRoute = {
  path: "/set-password",
  component: SetPassword
};

export const ChangePasswordRoute = {
  path: "/change-password",
  component: ChangePassword
};

export const onboardPayrollRoute = {
  path: "/onboard-company-payroll",
  component: OnboardPayroll
};

export const onboardUserRoute = {
  path: "/onboard-user",
  component: OnboardUser
};

export const verifyEmailRoute = {
  path: "/verify-email",
  component: VerifyEmail
};

export const onboardSuccessRoute = {
  path: "/onboard-successfull",
  component: OnboardSuccess
};
